import { render, staticRenderFns } from "./album.vue?vue&type=template&id=6f92a1fe&scoped=true&"
import script from "./album.vue?vue&type=script&lang=ts&"
export * from "./album.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f92a1fe",
  null
  
)

export default component.exports